export const API_GATE_WAY = import.meta.env.VITE_OZONE_DEV_API;
export const SOCKET_API = import.meta.env.VITE_SOCKET_API;
export const API_ROUTES = {
  POST_LOGIN: '/v1/OTP/Verify',
  POST_REQUEST_CALL: '/v1/help/RequestCall',
  POST_CANCEL_CALL: '/v1/help/CancelCall',
  POST_PAYMENT_BIOMETRIC_OPTIONS: '/v1/BiometricAuth/payment/options',
  POST_DEVICE_CHECK: '/v1/BiometricAuth/device-check',
  POST_INIT_OTP: '/v1/PaymentGatewayRequests/Initialize',
  POST_RETRY: '/v1/OTP/Retry',
  GET_INVOICES: '/v1/invoices',
  GET_SEGMENTS: '/v1/Segments',
  GET_VOUCHERS: '/v1/Vouchers',
  POST_VALIDATION_SEGMENTS: '/v1/SegmentTypes/ValidateSelectedSegmentsAndVouchers',
  POST_VALIDATE_SEGMENTS_AND_VOUCHERS: '/v1/SegmentTypes/ValidateSegmentsAndVouchers',
  POST_CREATE_TRANSACTIONS: '/v1/TransactionRequests/Create',
  POST_CONFIRM: '/v1/TransactionRequests/Confirm',
  GET_INVOICE_RECEIPT: '/v1/Invoices/InvoiceReceipt',
  GET_Advertisement: '/v1/Advertisement',
  GET_PROVIDER_VISIBILITY: '/v1/SegmentTypes/WalletProviderWithIdInputVisibility',
  //
  PURCHASE_CANCELLATION: '/transaction/v1/app/payments/cancel',
  GET_COUPONS: '/voucher/v1/app/customer-list',
  POST_PURCHASE: '/transaction/v1/app/payments',
  ADD_GIFT_CARDS: '/gift-card/v1/app/gift-cards/assign',
  GET_GIFT_CARDS: '/gift-card/v1/app/gift-cards',
  GET_BANK_RECEIPT: (token: string | null) => `/transaction/v1/app/payments/${token}/bank`,
  POST_AVAILABLE_SOURCES: '/transaction/v1/app/payments/available-sources',
  LIVE_STREAMING: '/socket/liveReplayHub',
  POST_CHECK_WALLET_INQUIRY: '/v1/Segments/CheckWalletInquiry',
};
